var _rect, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzleBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1080,
    viewBox: "0 0 1440 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_239)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: -164,
    width: 1585,
    height: 780
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 177.234,
    width: 546.154,
    height: 217,
    rx: 108.5,
    transform: "rotate(-44.8585 395 177.234)",
    fill: "white",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.554 312.5C181.457 301.009 203.428 293.551 226.212 290.552C248.997 287.552 272.15 289.069 294.348 295.017C316.546 300.965 337.355 311.228 355.588 325.218C373.82 339.208 389.118 356.652 400.609 376.554C412.1 396.457 419.558 418.428 422.557 441.212C425.557 463.997 424.039 487.15 418.091 509.348C412.143 531.546 401.881 552.355 387.891 570.588C373.901 588.82 356.457 604.118 336.554 615.609L249.054 464.054L161.554 312.5Z",
    fill: "#F1812C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.88 54.7662C1436.64 74.8142 1421.57 92.453 1403.52 106.675C1385.47 120.898 1364.79 131.426 1342.67 137.658C1320.55 143.889 1297.42 145.703 1274.6 142.996C1251.78 140.288 1229.71 133.112 1209.66 121.877L1295.21 -30.7855L1447.88 54.7662Z",
    fill: "#FF9F56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.91 282.387C1114.68 295.044 1126.47 347.1 1095.12 376.087L971.671 490.222C940.319 519.208 889.346 503.386 879.918 461.741L842.798 297.766C833.37 256.122 872.56 219.888 913.339 232.546L1073.91 282.387Z",
    fill: "#FFD5A8",
    fillOpacity: 0.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_239)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#FFD5A8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleBackground);
export default __webpack_public_path__ + "static/media/PuzzleBackground.afa5116cc0deacf388c18c58113e7896.svg";
export { ForwardRef as ReactComponent };